import axios from 'axios';
import { API_URL } from 'configs'

export const EMAIL_REPORT_SETUP_REQUEST = 'EMAIL_REPORT_SETUP_REQUEST'
export const EMAIL_REPORT_SETUP_SUCCESS = 'EMAIL_REPORT_SETUP_SUCCESS'
export const EMAIL_REPORT_SETUP_VALIDATION_ERROR = 'EMAIL_REPORT_SETUP_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_EMAIL_REPORT_SETUP_FEILD_VALIDATION_ERROR = "HIDE_EMAIL_REPORT_SETUP_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_EMAIL_REPORT_SETUP_LIST = 'REDIRECT_TO_EMAIL_REPORT_SETUP_LIST'
export const EMAIL_REPORT_SETUP_GET_SUCCESS = 'EMAIL_REPORT_SETUP_GET_SUCCESS'
export const EMAIL_REPORT_SETUP_SERVER_SUCCESS = 'EMAIL_REPORT_SETUP_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const emailReportSetupRequest = () => ({
  type: EMAIL_REPORT_SETUP_REQUEST,
})

export const emailReportSetupServerListSuccess = () => ({
  type:EMAIL_REPORT_SETUP_SERVER_SUCCESS,
})

const emailReportSetupListSuccess = emailReportSetupList => ({
  type:EMAIL_REPORT_SETUP_SUCCESS,
  emailReportSetupList: emailReportSetupList,
})

const emailReportSetupFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type:EMAIL_REPORT_SETUP_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const emailReportSetupAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(emailReportSetupSuccessNotification(message))
  dispatch(redirectToEmailReportSetupList())
}

export const redirectToEmailReportSetupList = () => ({
  type: REDIRECT_TO_EMAIL_REPORT_SETUP_LIST,
})

const getEmailReportSetupSuccess = (response, action) => ({
  type:EMAIL_REPORT_SETUP_GET_SUCCESS,
  record: response,
  actionType: action
})

const emailReportSetupSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideEmailReportSetupValidationError = (feild_key) => ({
  type: HIDE_EMAIL_REPORT_SETUP_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const emailReportSetupListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_report_setup/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(emailReportSetupListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getEmailReportSetupById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_report_setup/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {

        console.log('dataaaa' , response.data ,action);
        dispatch(hideCommonLoader())
        dispatch(getEmailReportSetupSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addEmailReportSetup = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_report_setup/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        emailReportSetupAddUpadteSuccess('Email Report Setup Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateEmailReportSetup = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_report_setup/update/" + data.id ,{
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        emailReportSetupAddUpadteSuccess('Email Report Setup Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}



export const deleteEmailReportSetup = (emailReportSetupId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_report_setup/delete/" + emailReportSetupId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data:{
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(emailReportSetupSuccessNotification('Email Report Setup deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(emailReportSetupFailure(err))
    }
  }
  catch (e) {
    dispatch(emailReportSetupFailure('Unable to perform action.Something went wrong'))
  }
}   